import React, {Component} from 'react';
import {Label} from "reactstrap";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import Alert from "react-s-alert";
import {API_BASE_URL} from "../../constants";
import Select from "../../local_node_modules/react-select"
import LoadingIndicator from "../../common/LoadingIndicator";

class ExcelDownloadForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            isLoading: false,
            selectedColumns: [],
            options: [],
            downloadTypes: [
                {id: 0, value: "Sütun Seçmeden Excel İndir"},
                {id: 1, value: "Excele Aktarırken Sütun Seç"},
            ],
            selectDownload: null,
        };

        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelectExcelInfoChange = this.onSelectExcelInfoChange.bind(this);
        this.onSelectDownloadType = this.onSelectDownloadType.bind(this);
    }

    componentDidMount() {
        let options = [];
        if (this.props.content && this.props.content.length > 0) {
            options = this.props.content;
        }
        this.setState({options});
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    onSelectDownloadType(e) {
        console.log("e", e);
        let selectDownload = e.value;
        this.setState({selectDownload});
    }

    async exportXls() {
        let self = this;
        let data = this.props.data;
        if (this.state.selectDownload === 1 && this.state.selectedColumns.length > 0)
            data.headers = this.state.selectedColumns;
        let url = this.props.url;
        let params = {
            url: url,
            method: "post",
            data: data,
        };
        Alert.success(
            "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'İNDİRME TALEPLERİNİZ'" +
            " butonuna tıklayarak excel dosyasını indirebilirsiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 6000
            });
        await request(params).then(() => {
            self.cancelProcess();
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    onSelectExcelInfoChange(e) {
        let selectedColumns;
        if (e === null || !Array.isArray(e) || (Array.isArray(e) && e.length === 0)) {
            selectedColumns = [];
        } else {
            selectedColumns = e.map(item => (item.data));

        }
        this.setState({selectedColumns});
    }

    onChange(e) {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        }, () => {
            console.log("state:", this.state)
        })
    }

    excelContentOptions = () => {
        if (this.props.content.length > 0) {
            let params = {
                url: API_BASE_URL + "/uye/memberContent",
                method: "post",
                data: this.props.content
            };
            return request(params)
                .then((response) => {
                    return response.data;
                }).then((data) => {
                    return {
                        options: data.map(item => ({
                            label: item,
                            value: item,
                            data: item
                        }))
                    };
                });
        } else {
            return Promise.resolve({options: []});
        }
    };

    render() {
        return (
            <div className='financial-transaction-form-container'>
                {(this.state.isLoading) && <div className="loader"><LoadingIndicator/></div>}
                <div className='card-header'>
                </div>
                <div className="card-body mt-1">
                    <div className="FormRenk col-sm-12">
                        <div className="col-sm-12  row">
                            <Label className="col-sm-3">İndirme Seçenekleri</Label>
                            <Select className="col-sm-8 form-control"
                                    id="selectedCity"
                                    name="selectedCity"
                                    value={this.state.selectDownload}
                                    clearable={false}
                                    placeholder="İndirme Türü Seçiniz "
                                    noResultsText="Kayıt bulunamadı."
                                    onChange={(e) => this.onSelectDownloadType(e)}
                                    options={this.state.downloadTypes.map(item => ({
                                        value: item.id,
                                        label: item.value
                                    }))}
                            />
                        </div>
                        {this.state.selectDownload === 1 &&
                        <div className="col-sm-12  row">
                            <Label className="col-sm-3">Sütunları Seç: </Label>
                            <div className="col-sm-8 form-control">
                                <Select.Async
                                    multi={true}
                                    clearable={true}
                                    ignoreAccents={false}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    clearValueText="Temizle"
                                    placeholder={"Excele aktarmak istediğiniz sütunları seçiniz."}
                                    noResultsText={"Kayıt bulunamadı"}
                                    searchPromptText={"Excele aktarmak istediğiniz sütunların adıyla arama yapabilirsiniz."}
                                    style={{flex: 1}}
                                    onChange={(e) => this.onSelectExcelInfoChange(e)}
                                    value={this.state.selectedColumns
                                        .map(item => ({
                                            label: item,
                                            value: item,
                                            data: item
                                        }))}
                                    loadOptions={this.excelContentOptions}
                                />
                            </div>
                        </div>}
                    </div>
                </div>
                {/* CARD FOOTER */}
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"170px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                Vazgeç
                            </button>
                        </div>
                        <div className='col-sm-8'/>
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"170px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.selectDownload === null}
                                    onClick={() => this.exportXls()}>
                                İndirme Başlat
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ExcelDownloadForm;



// WEBPACK FOOTER //
// ./src/page/memberList/ExcelDownloadForm.js